import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {PersonTypeEnum, SearchDoctorByEnum} from './types';

const PERSON_TYPE_OPTS = [
	{
		label: 'Pessoa física',
		value: PersonTypeEnum.PHYSICAL_PERSON,
		dataTagId: RefundTaggingEnum.CLICK_LABEL_PESSOA_FISICA,
	},
	{
		label: 'Pessoa jurídica',
		value: PersonTypeEnum.LEGAL_PERSON,
		dataTagId: RefundTaggingEnum.CLICK_LABEL_PESSOA_JURIDICA,
	},
];
const SEARCH_DOCTOR_BY_OPTS = [
	{
		label: 'CPF',
		value: SearchDoctorByEnum.DOCUMENT,
		dataTagId: RefundTaggingEnum.CLICK_PESQUISAR_MEDICO_POR_CPF,
	},
	{
		label: 'Número do conselho',
		value: SearchDoctorByEnum.COUNCIL_NUMBER,
		dataTagId: RefundTaggingEnum.CLICK_PESQUISAR_MEDICO_POR_NUMERO_CONSELHO,
	},
];

export {PERSON_TYPE_OPTS, SEARCH_DOCTOR_BY_OPTS};
